$shm_hitalama_select_list $mol_select_list
	Add_option $mol_button_minor
		sub /
			<= Add_option_icon $mol_icon_plus
		click? <=> add_option? null
	options? /string
	pick_enabled true
	Option_delete* $mol_button_minor
		click? <=> delete*? null
		sub /
			<= Delete_icon* $mol_icon_trash_can
